import "can/component/";
import "can/view/stache/";
import _some from "lodash/some";
import Refresh from "src/components/shared/refresh";
import ViewModel from "src/components/header/header.vm";

var pageURL = window.location.href;
var lastURLSegment = pageURL.substr(pageURL.lastIndexOf('/') + 1);
// auth server URL for USA Region Prod Env
var SwitchAppURL = "https://as-us.prod.vistracks.com/oauth2/generateToken";
// Generate Token URL for Prod Env
var hostNameURL = "https://auth.azuga.com/azuga-as/oauth2/jwtlogin";
can.Component.extend({
    tag: "header-navigation",
    template: can.view("src/components/header/header-navigation.stache"),
    viewModel: ViewModel,
    events: {
        inserted: function () {
            "use strict";
            let checkUrl = location.pathname;

            Refresh.attr("viewModel", this.viewModel);

            let permissions = Vistracks.myUser.permissions;
            let isDriver = _some(permissions, item => item.name === "PERM_IS_DRIVER");
            let isAssetAdmin = _some(permissions, item => item.name === "PERM_EDIT_EQUIPMENT");
            let isFleetManager = _some(permissions, item => item.name === "PERM_IS_FLEET_MANAGER");
            let isUserAdmin = _some(permissions, item => item.name === "PERM_IS_USER_ADMIN");
            let isAccountAdmin = _some(permissions, item => item.name === "PERM_IS_ACCOUNT_ADMIN");

            const userIsDriverInPortal = (isDriver && isAssetAdmin) &&
                (!isUserAdmin && !isFleetManager && !isAccountAdmin) && checkUrl.indexOf("portal");

            if (userIsDriverInPortal) {
                Cookies.remove("JSESSIONID", { path: "/" });
                window.location.replace("/driver-portal/app.html");
            }

            const switchAppButtonVisibility = Vistracks.myAccount.accountProperties.switchAppButtonVisibility;
            if (switchAppButtonVisibility) {
                if (switchAppButtonVisibility.value === "both") {
                    this.viewModel.attr("data.isSwitchAppButtonVisible", true);
                    this.viewModel.attr("data.isClassicFleetVisible", true);
                    this.viewModel.attr("data.isFleetVersionTwoVisible", true);
                } else if (switchAppButtonVisibility.value === "classic") {
                    this.viewModel.attr("data.isSwitchAppButtonVisible", true);
                    this.viewModel.attr("data.isClassicFleetVisible", true);
                    this.viewModel.attr("data.isFleetVersionTwoVisible", false);
                } else if (switchAppButtonVisibility.value === "webv2") {
                    this.viewModel.attr("data.isSwitchAppButtonVisible", true);
                    this.viewModel.attr("data.isClassicFleetVisible", false);
                    this.viewModel.attr("data.isFleetVersionTwoVisible", true);
                }
            }
            if (pageURL.toString().includes('ca')) {
                // auth server URL for canada Region
                SwitchAppURL = "https://as-ca.prod.vistracks.com/oauth2/generateToken";
            } else if (pageURL.toString().includes('dev-tracking')) {
                SwitchAppURL = "https://dev-as.dev.vistracks.com/oauth2/generateToken";
                hostNameURL = "https://venus-as.dev.azuga.com/azuga-as/oauth2/jwtlogin";
            } else if (pageURL.toString().includes('qa-tracking')) {
                SwitchAppURL = "https://qa-as.dev.vistracks.com/oauth2/generateToken";
                hostNameURL = "https://venus-as.dev.azuga.com/azuga-as/oauth2/jwtlogin";
            } else if (pageURL.toString().includes('uat-tracking')) {
                SwitchAppURL = "https://uat-as.dev.vistracks.com/oauth2/generateToken";
                hostNameURL = "https://venus-as.dev.azuga.com/azuga-as/oauth2/jwtlogin";
            }
            can.ajax({
                url: SwitchAppURL,
                type: "POST",
                data: { userName: Vistracks.myUser.email },
                dataType: "JSON",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
            }).then((oauth2GenerateToken) => {
                if (oauth2GenerateToken) {
                    const token = btoa(oauth2GenerateToken.token);
                    const clientId = btoa(oauth2GenerateToken.clientId);
                    this.viewModel.attr("classicUrl", `${hostNameURL}?clientId=${clientId}&token=${token}&loginType=7&isWebV2=false`);
                    this.viewModel.attr("webV2Url", `${hostNameURL}?clientId=${clientId}&token=${token}&loginType=7&isWebV2=true`);
                }
            });
        },

        "#classic_fleet_url click": function () {
            "use strict";
            const classicUrl = this.viewModel.attr("classicUrl");
            can.ajax({
                url: classicUrl,
                type: "GET",
                dataType: "JSON",
                success: function (data, textStatus, jqXHR) {
                      if (jqXHR.status === 200) {
                            window.open(classicUrl, '_blank');
                        } else {
                            toastr.error(Locale.translate("You don't have access to Azuga Fleet. Please contact customer service for more information"));
                        }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status === 200) {
                            window.open(classicUrl, '_blank');
                    } else {
                        toastr.error(Locale.translate("You don't have access to Azuga Fleet. Please contact customer service for more information"));
                    }
                }
            });
        },
        "#fleet_v2_url click": function () {
            "use strict";
            const webv2Url = this.viewModel.attr("webV2Url");
            can.ajax({
                url: webv2Url,
                type: "GET",
                dataType: "JSON",
                success: function (data, textStatus, jqXHR) {
                    if (jqXHR.status === 200) {
                        window.open(webv2Url, '_blank');
                    } else {
                        toastr.error(Locale.translate("You don't have access to Azuga Fleet. Please contact customer service for more information"));
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.status === 200) {
                        window.open(webv2Url, '_blank');
                } else {
                    toastr.error(Locale.translate("You don't have access to Azuga Fleet. Please contact customer service for more information"));
                }
                }
            });
        },
        "#sidebar-toggle click": function () {
            "use strict";

            $("body").toggleClass("hide-sidebar");

            return false;
        }
    }
});
